import React from "react";
import { Iconography } from "@hid-galaxy-ui/galaxy-react";
import {
  Checkbox,
  FormControl,
  ListItemText,
  MenuItem,
  Select,
} from "@mui/material";
import type { IntegrationTableColumn } from "./integrationStatusColumns";

type IntegrationColumnsDropdownProps = {
  availableColumns: IntegrationTableColumn[];
  visibleColumnKeys: string[];
  onVisibleColumnKeysChange: (keys: string[]) => void;
};

const SelectIcon = (props: { className?: string }) => (
  <Iconography
    icon="angleDown"
    className={`partner-columns-select-icon ${props.className || ""}`}
  />
);

const IntegrationColumnsDropdown: React.FC<IntegrationColumnsDropdownProps> = ({
  availableColumns,
  visibleColumnKeys,
  onVisibleColumnKeysChange,
}) => {
  return (
    <FormControl size="small" className="partner-columns-select-wrap">
      <Select
        multiple
        value={visibleColumnKeys}
        onChange={(e) => onVisibleColumnKeysChange(e.target.value as string[])}
        IconComponent={SelectIcon}
        displayEmpty
        renderValue={() => (
          <span className="partner-columns-select-value">
            <span className="vertical-bars" aria-hidden>
              <i />
              <i />
              <i />
            </span>
            <span>Columns</span>
          </span>
        )}
        className="partner-columns-select"
        MenuProps={{
          PaperProps: { className: "partner-columns-menu-paper" },
        }}
      >
        <MenuItem disableRipple disableTouchRipple className="partner-columns-menu-header">
          <span>Table Columns</span>
          <span className="menu-actions">
            <button
              type="button"
              onClick={(event) => {
                event.stopPropagation();
                onVisibleColumnKeysChange(availableColumns.map((col) => col.key));
              }}
            >
              All
            </button>
            <button
              type="button"
              onClick={(event) => {
                event.stopPropagation();
                onVisibleColumnKeysChange([]);
              }}
            >
              None
            </button>
          </span>
        </MenuItem>

        {availableColumns.map((column) => (
          <MenuItem key={column.key} value={column.key}>
            <Checkbox checked={visibleColumnKeys.includes(column.key)} />
            <ListItemText primary={column.label} />
          </MenuItem>
        ))}

        <MenuItem disableRipple disableTouchRipple className="partner-columns-menu-footer">
          {visibleColumnKeys.length} of {availableColumns.length} columns visible
        </MenuItem>
      </Select>
    </FormControl>
  );
};

export default IntegrationColumnsDropdown;
